import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/images/placeholders/small-map.png'


const _hoisted_1 = { class: "box mb-5 px-3 py-5 is-flex" }
const _hoisted_2 = { class: "is-size-6_5" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "bold-text" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "bold-text" }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "bold-text" }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "bold-text" }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "bold-text" }
const _hoisted_13 = { class: "badges" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/jobs/${_ctx.job.uuid}/details`
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("table", null, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _cache[5] || (_cache[5] = _createElementVNode("td", null, [
                _createElementVNode("div", { class: "map px-2 is-flex" }, [
                  _createElementVNode("img", {
                    class: "is-align-self-center is-justify-content-center map-image",
                    src: _imports_0
                  })
                ])
              ], -1)),
              _createElementVNode("td", null, [
                _createElementVNode("div", _hoisted_2, [
                  (_ctx.job.date)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _cache[0] || (_cache[0] = _createTextVNode("Date: ", -1)),
                        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.date), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.job.start_time)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[1] || (_cache[1] = _createTextVNode("Arrival Window: ", -1)),
                        _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.time), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.job.device)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _cache[2] || (_cache[2] = _createTextVNode("Device: ", -1)),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.job.device), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.job.description)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _cache[3] || (_cache[3] = _createTextVNode("Description: ", -1)),
                        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.job.description), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.job.zipcode)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _cache[4] || (_cache[4] = _createTextVNode("Zipcode: ", -1)),
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.job.zipcode), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    (_ctx.job.is_diagnostic)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "m-1 px-2 py-1 is-radius-3 is-size-7 medium-text",
                          style: _normalizeStyle({ background: _ctx.colors[_ctx.filters.DIAGNOSTIC].color})
                        }, " Diagnostic ", 4))
                      : _createCommentVNode("", true),
                    (_ctx.job.is_completed)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: "m-1 px-2 py-1 is-radius-3 is-size-7 medium-text",
                          style: _normalizeStyle({ background: _ctx.colors[_ctx.filters.COMPLETED].color})
                        }, " Complete ", 4))
                      : _createCommentVNode("", true),
                    (_ctx.job.is_followup)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 2,
                          class: "m-1 px-2 py-1 is-radius-3 is-size-7 medium-text",
                          style: _normalizeStyle({ background: _ctx.colors[_ctx.filters.FOLLOW_UP].color})
                        }, " Follow-up ", 4))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}